module.exports = {
	"id": "ww",
	"name": "Worldwide",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.004879,
			"5": 0.004879,
			"6": 0.004879,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.004879,
			"11": 0.029274,
			"12": 0.009758,
			"13": 0.004879,
			"14": 0.004879,
			"15": 0.009758,
			"16": 0.009758,
			"17": 0.009758,
			"18": 0.019516,
			"19": 0.019516,
			"20": 0.014637,
			"21": 0.019516,
			"22": 0.04879,
			"23": 0.014637,
			"24": 0.039032,
			"25": 0.019516,
			"26": 0.029274,
			"27": 0.019516,
			"28": 0.019516,
			"29": 0.024395,
			"30": 0.024395,
			"31": 0.092701,
			"32": 0.019516,
			"33": 0.04879,
			"34": 0.039032,
			"35": 0.04879,
			"36": 0.034153,
			"37": 0.034153,
			"38": 0.043911,
			"39": 0.058548,
			"40": 0.04879,
			"41": 0.04879,
			"42": 0.078064,
			"43": 0.282982,
			"44": 0.082943,
			"45": 0.312256,
			"46": 0.087822,
			"47": 0.121975,
			"48": 0.151249,
			"49": 1.634465,
			"50": 0.24395,
			"51": 0.663544,
			"52": 0.575722,
			"53": 18.169396,
			"54": 4.752146,
			"55": 0.078064,
			"56": 0.024395,
			"57": null
		},
		"firefox": {
			"2": 0.014637,
			"3": 0.043911,
			"4": 0.009758,
			"5": 0.004879,
			"6": null,
			"7": null,
			"8": 0.019516,
			"9": null,
			"10": 0.009758,
			"11": 0.009758,
			"12": 0.014637,
			"13": 0.004879,
			"14": 0.004879,
			"15": 0.019516,
			"16": 0.014637,
			"17": 0.004879,
			"18": 0.014637,
			"19": 0.009758,
			"20": 0.009758,
			"21": 0.019516,
			"22": 0.009758,
			"23": 0.014637,
			"24": 0.014637,
			"25": 0.029274,
			"26": 0.009758,
			"27": 0.014637,
			"28": 0.014637,
			"29": 0.019516,
			"30": 0.014637,
			"31": 0.034153,
			"32": 0.014637,
			"33": 0.019516,
			"34": 0.024395,
			"35": 0.029274,
			"36": 0.024395,
			"37": 0.024395,
			"38": 0.082943,
			"39": 0.043911,
			"40": 0.039032,
			"41": 0.043911,
			"42": 0.043911,
			"43": 0.151249,
			"44": 0.09758,
			"45": 0.161007,
			"46": 0.14637,
			"47": 0.473263,
			"48": 0.434231,
			"49": 4.556986,
			"50": 0.14637,
			"51": 0.004879,
			"52": null,
			"3.5": 0.024395,
			"3.6": 0.073185
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.029274,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.004879,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.014637,
			"28": 0.004879,
			"29": 0.004879,
			"30": 0.004879,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.009758,
			"35": 0.004879,
			"36": 0.034153,
			"37": 0.053669,
			"38": 0.058548,
			"39": 0.019516,
			"40": 0.380562,
			"41": 0.063427,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.009758,
			"10.5": null,
			"10.6": 0.009758,
			"11.1": null,
			"11.5": 0.004879,
			"11.6": 0.024395,
			"12.1": 0.14637
		},
		"safari": {
			"0": null,
			"4": 0.019516,
			"5": 0.04879,
			"6": 0.009758,
			"7": 0.039032,
			"8": 0.131733,
			"9": 0.175644,
			"10": 1.02459,
			"3.1": null,
			"3.2": null,
			"5.1": 0.078064,
			"6.1": 0.073185,
			"7.1": 0.019516,
			"9.1": 0.863583
		},
		"ios_saf": {
			"8": 0,
			"10": 6.19273874188,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.166887143318,
			"8.1-8.4": 0.308316925791,
			"9.0-9.2": 0.147086973772,
			"9.3": 2.24401921524
		},
		"android": {
			"3": 0,
			"4": 0.0540020697674,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00675025872093,
			"4.1": 0.194793180233,
			"4.2-4.3": 0.486982950581,
			"4.4": 1.11668565698,
			"4.4.3-4.4.4": 1.12632888372
		},
		"ie": {
			"6": 0.0301181524202,
			"7": 0.0250984603502,
			"8": 0.441732902163,
			"9": 0.296161832132,
			"10": 0.271063371782,
			"11": 3.80492658908,
			"5.5": null
		},
		"op_mob": {
			"0": 0.305128258193,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00847578494982
		},
		"edge": {
			"12": 0.068306,
			"13": 0.346409,
			"14": 1.092896
		},
		"ie_mob": {
			"10": 0.114104535211,
			"11": 0.464568464789
		},
		"bb": {
			"7": 0.05761125,
			"10": null
		},
		"samsung": {
			"0": 3.338892
		},
		"and_uc": {
			"0": 9.16659
		},
		"op_mini": {
			"0": 4.11093995686
		},
		"and_chr": {
			"0": 23.197575
		},
		"and_ff": {
			"0": 0.035847
		}
	},
	"total": 97.8383215579
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-ww.json
 ** module id = 696
 ** module chunks = 0
 **/